import { findSceneNode, getSceneNodeChildren, type CurvaDocument } from "@/document/model/document";
import type { SceneNode } from "@/document/model/nodes";

export function contextMenuConvertTarget(document: CurvaDocument, nodeId: string): "frame" | "group" | undefined {
  const node = findSceneNode(document, nodeId);
  if (node?.type === "frame") {
    return "group";
  }
  if (node?.type === "group") {
    return "frame";
  }
  return undefined;
}

export function insertionPointAboveNode(document: CurvaDocument, nodeId: string): { parentId: string; index: number } | undefined {
  for (const page of document.pages) {
    const directIndex = page.children.findIndex(node => node.id === nodeId);
    if (directIndex >= 0) {
      return { parentId: page.id, index: directIndex + 1 };
    }

    const nested = insertionPointAboveNodeInChildren(page.children, nodeId);
    if (nested) {
      return nested;
    }
  }

  return undefined;
}

function insertionPointAboveNodeInChildren(children: SceneNode[], nodeId: string): { parentId: string; index: number } | undefined {
  for (const node of children) {
    const nodeChildren = getSceneNodeChildren(node);
    if (!nodeChildren) {
      continue;
    }

    const directIndex = nodeChildren.findIndex(child => child.id === nodeId);
    if (directIndex >= 0) {
      return { parentId: node.id, index: directIndex + 1 };
    }

    const nested = insertionPointAboveNodeInChildren(nodeChildren, nodeId);
    if (nested) {
      return nested;
    }
  }

  return undefined;
}
